import { IPlacement, QuestionCategories } from "@sp-crm/core";
import { AiSummary } from "components/ai-summary/ai-summary";
import { Notes } from "components/notes/index";
import { NgGrid } from "components/shared/grid";
import { WorkflowEntityExecutions } from "components/workflow/workflow-entity-executions";
import React from "react";
import { ResponsiveMode } from "store/reducers/responsive";
import { useResponsiveMode } from "store/selectors/hooks";
import { useTenantSettings } from "store/selectors/settings";
import { ClientAgreementSection } from "./client-agreement-section";
import { ClientBestContact } from "./client-best-contact";
import { ClientCurrentLocation } from "./client-current-location";
import { ClientInfoForm } from "./client-info-form";
import { PlacementReferralSource } from "./placement-referral-source";
import { LegacyPowerOfAttorney } from "./power-of-attorney";
import ClientQuestionSection from "./question-section";

interface PlacementOverviewTabProps {
    placement: IPlacement;
    onFieldChange: (fieldName: string, newValue: string) => void;
    onFieldChangeMulti: (fieldValues: Record<string, unknown>) => void;
    onSendDisclosure: () => void;
}

export const PlacementOverviewTab: React.FC<PlacementOverviewTabProps> = props => {
    const { placement, onFieldChange, onFieldChangeMulti, onSendDisclosure } = props;
    const {
        settings: { showClientFirst },
    } = useTenantSettings();
    const responsiveMode = useResponsiveMode();
    const isMobile = responsiveMode < ResponsiveMode.large;
    return (
        <NgGrid>
            <NgGrid.Column>
                {isMobile ? <Notes entityId={placement.id} entityType="Client" /> : null}
                {showClientFirst ? (
                    <>
                        <ClientInfoForm
                            placement={placement}
                            onFieldChange={onFieldChange}
                            onMultiFieldChange={onFieldChangeMulti}
                        />
                        <ClientCurrentLocation
                            placement={placement}
                            onFieldChange={onFieldChange}
                        />
                        <ClientBestContact
                            placement={placement}
                            onFieldChangeMulti={onFieldChangeMulti}
                        />
                    </>
                ) : (
                    <>
                        <ClientBestContact
                            placement={placement}
                            onFieldChangeMulti={onFieldChangeMulti}
                        />
                        <ClientInfoForm
                            placement={placement}
                            onFieldChange={onFieldChange}
                            onMultiFieldChange={onFieldChangeMulti}
                        />
                        <ClientCurrentLocation
                            placement={placement}
                            onFieldChange={onFieldChange}
                        />
                    </>
                )}
                <LegacyPowerOfAttorney
                    placement={placement}
                    onFieldChange={onFieldChange}
                />
            </NgGrid.Column>
            <NgGrid.Column>
                <AiSummary clientId={placement.id} />
                {isMobile ? null : <Notes entityId={placement.id} entityType="Client" />}
                <ClientQuestionSection
                    category={QuestionCategories.summary}
                    clientId={placement.id}
                />
                <PlacementReferralSource
                    placement={placement}
                    onFieldChange={onFieldChange}
                />
                <ClientAgreementSection
                    placement={placement}
                    onFieldChange={onFieldChange}
                    onSendDisclosure={onSendDisclosure}
                />
                <WorkflowEntityExecutions entity={placement} />
            </NgGrid.Column>
        </NgGrid>
    );
};
